<div class="container">
  <div class="layout-row m-b-10">
    <mat-form-field class="flex-fill">
      <mat-label>{{ 'labels.inputs.Filter By Version' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8 container">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Version' | translate }}</th>
        <td mat-cell *matCellDef="let jobHistoryData">{{ jobHistoryData.version }}</td>
      </ng-container>

      <ng-container matColumnDef="run_start_time">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Start Time' | translate }}</th>
        <td mat-cell *matCellDef="let jobHistoryData">{{ jobHistoryData.jobRunStartTime | datetimeFormat }}</td>
      </ng-container>

      <ng-container matColumnDef="run_end_time">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.End Time' | translate }}End time</th>
        <td mat-cell *matCellDef="let jobHistoryData">{{ jobHistoryData.jobRunEndTime | datetimeFormat }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Status' | translate }}</th>
        <td mat-cell *matCellDef="let jobHistoryData">
          @if (jobHistoryData.status === 'success') {
            <fa-icon
              class="success"
              matTooltip="{{ 'tooltips.Successful' | translate }}"
              matTooltipPosition="right"
              icon="check-circle"
              size="lg"
            ></fa-icon>
          }
          @if (!(jobHistoryData.status === 'success')) {
            <fa-icon
              class="fail"
              matTooltip="{{ 'tooltips.Failed' | translate }}"
              matTooltipPosition="right"
              icon="times-circle"
              size="lg"
            ></fa-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="run_type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Run Type' | translate }}</th>
        <td mat-cell *matCellDef="let jobHistoryData">{{ jobHistoryData.triggerType }}</td>
      </ng-container>

      <ng-container matColumnDef="error_log">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Error Log' | translate }}</th>
        <td mat-cell *matCellDef="let jobHistoryData">
          @if (!(jobHistoryData.status === 'success')) {
            <button
              mat-icon-button
              class="errorlog"
              matTooltip="{{ 'tooltips.Error Log' | translate }}"
              matTooltipPosition="right"
              (click)="openError(jobHistoryData.version)"
            >
              <fa-icon icon="exclamation-circle" size="lg"></fa-icon>
            </button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="select-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>

    <div class="layout-row layout-align-center">
      <button type="button" color="primary" mat-raised-button [routerLink]="['../']">
        {{ 'labels.buttons.Back' | translate }}
      </button>
    </div>
  </div>
</div>
